import { Static, Type } from '@sinclair/typebox';
import { SurveyStates } from '../../enums/SurveyStates';

export const taskDefinitionTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    clientCompanyId: Type.String({ format: 'uuid' }),
    name: Type.String(),
    surveyStatus: Type.Enum(SurveyStates),
    order: Type.Integer(),
    created_at: Type.String(),
    updated_at: Type.String(),
});

/** Definition of survey workflow tasks */
export type TaskDefinition = Static<typeof taskDefinitionTableSchema>;
